/**
 * Reducer function to calculate everything in the order.line_items
 * Shipping calculated with shipping = true switch
 * @param {object} order
 * @param {boolean} shipping
 */
export function orderTotal(order, shipping = true, priceType = 'price') {
  if (order && typeof order.line_items !== 'undefined' && order.line_items.length > 0) {
    // Calculate order total
    const calculatedOrderTotal =
    order.line_items.reduce((total, num) => total + num[priceType] * num.quantity, 0);

    // Calculate shipping total
    const calculatedShippingTotal =
    order.shipping_lines.reduce((total, num) => total + parseFloat(num.total), 0);

    // shipping flag is used here
    return shipping
      ? Math.round(parseFloat(calculatedOrderTotal + calculatedShippingTotal) * 100) / 100
      : Math.round(parseFloat(calculatedOrderTotal) * 100) / 100;
  }
  return 0;
}

/**
 * Adds the subscription length to todays date
 */
export function nextBillingDate(subLength, subPeriod, startDate = null) {
  const d = startDate ? new Date(startDate) : new Date();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();

  let addYear = 0;
  let addMonth = 0;
  let addDay = 0;

  if (subPeriod === 'year') addYear = parseInt(subLength, 10);
  if (subPeriod === 'month') addMonth = parseInt(subLength, 10);
  if (subPeriod === 'day') addDay = parseInt(subLength, 10);

  return new Date(year + addYear, month + addMonth, day + addDay);
}

export function isMemberShip(order) {
  return !!(typeof order.line_items !== 'undefined'
    && typeof order.line_items[0] !== 'undefined'
    && order.line_items[0].type === 'subscription');
}
